import { render, staticRenderFns } from "./DynamicProducts.vue?vue&type=template&id=45020414&"
import script from "./DynamicProducts.vue?vue&type=script&lang=js&"
export * from "./DynamicProducts.vue?vue&type=script&lang=js&"
import style0 from "./DynamicProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports